import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, ValidatorFn } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SrpValidators } from '@salesrun/ngx-validation';
import { srpTrim } from '@salesrun/trim';
import { Subscription } from 'rxjs';
import { DialogButtonState } from '../DialogButtonState';
import { INPUT_DIALOG_CHOICE } from './constants';
import { InputDialogResult } from './InputDialogResult';


@Component({
    selector: 'srp-input-dialog',
    templateUrl: './srp-input-dialog.component.html',
    styleUrls: ['./srp-input-dialog.component.scss'],
    standalone: false
})
export class SrpInputDialogComponent implements OnInit, OnDestroy {
    control: FormControlTyped<string>;

    original: string;
    title: string;
    valueTitle: string;
    validators: ValidatorFn[] = [];
    occupiedNames: string[];
    maxLength = 100;
    submitButton = 'OK';
    multiline = false;
    matHintVisible = true;
    choices?: DialogButtonState[];
    message: string;
    requiredErrorMessage: string;
    submitOnEnter: boolean;
    private sub: Subscription;

    constructor(private _dialogRef: MatDialogRef<SrpInputDialogComponent, InputDialogResult>) {
    }
    ngOnInit(): void {
        this.control = new UntypedFormControl(this.original, [...this.validators, SrpValidators.uniqueString(this.occupiedNames)]);
    }
    submit(): void {
        if (this.control.valid) {
            this._dialogRef.close({
                choice: INPUT_DIALOG_CHOICE.Submit,
                body: this.control.value,
            });
        }
    }
    cancel(): void {
        this._dialogRef.close({
            choice: INPUT_DIALOG_CHOICE.Cancel,
        });
    }

    onButtonClick(choice: string | DialogButtonState): void {
        this._dialogRef.close({
            choice: this.getChoice(choice),
            body: srpTrim(this.control.value),
        });
    }

    onPressEnter(): void {
        if (this.submitOnEnter) {
            this.submit();
        }
    }

    getChoice(choice: string | DialogButtonState): string {
        return typeof choice === 'string' ? choice : choice.title;
    }

    getColor(choice: string | DialogButtonState): string {
        return typeof choice === 'string' ? 'primary' : choice.color;
    }

    ngOnDestroy(): void {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

}